import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './main/main.component';
import { ErrorLayoutComponent } from './error/error.component';
//import { AppTopbarComponent } from '../topbar/app.topbar.component';
import { AppFooterComponent } from '../../app.footer.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppTopbarSearchResultComponent } from 'src/app/shared/topbar/app.topbar.searchresult.component';
import { AppSharedModule } from '../shared.module';
import { AppMenuModule } from '../menu/app.menu.module';
import { AppRightPanelModule } from 'src/app/components/rightpanel/rightpanel.module';
import { AppBreadcrumbModule } from '../breadcrumb/app.breadcrumb.module';
import { SmartActionsModule } from 'src/app/components/smart-actions/smart-actions.module';
import { AppTopbarModule } from '../topbar/app.topbar.module';
import { PreviewFeatureModule } from '../preview-feature/preview-feature.module';


@NgModule({
    declarations: [
        MainLayoutComponent,
        ErrorLayoutComponent,
        AppTopbarSearchResultComponent,
        AppFooterComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        AppSharedModule,
        AppMenuModule,
        AppRightPanelModule,
        AppBreadcrumbModule,
        SmartActionsModule,
        AppTopbarModule,
        PreviewFeatureModule
    ],
    exports: [
        MainLayoutComponent,
        ErrorLayoutComponent
    ]
})
export class LayoutsModule {}
